import { render, staticRenderFns } from "./Promo.vue?vue&type=template&id=096a27de&scoped=true"
import script from "./Promo.vue?vue&type=script&lang=js"
export * from "./Promo.vue?vue&type=script&lang=js"
import style0 from "./Promo.vue?vue&type=style&index=0&id=096a27de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096a27de",
  null
  
)

export default component.exports